/**
 * Some Unity-like random APIs for easy porting
 */
export class Random {

    static get value() {
        return this._nextValue();
    }

    static _nextValue() {
        return Math.random();
    }

    static Range(a, b) {
        let max = Math.max(a, b);
        let min = Math.min(a, b);
        if (max === min) return min;
        return min + this.value * (max - min);
    }
}
